import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { opApiRequest } from 'src/api/apiRequest';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';
import fetchEmbroideryPalette from 'src/util/embroidery/fetchEmbroideryPalette';
import findCustomerPictureId from 'src/util/embroidery/findCustomerPictureId';

interface QuantizeResponse {
  url: string;
  colors: string[];
}

const handleQuantizedAssetRequestOperation = (assetId: string) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  try {
    const palette = await fetchEmbroideryPalette();
    const customerPictureId = findCustomerPictureId(getState(), assetId);

    if (!customerPictureId) {
      // eslint-disable-next-line no-console
      console.error('[OP-39631] Cannot find customerPictureId for asset:', assetId);
      sendPostMessage({
        type: MESSAGE_TYPE['design.setQuantizedAssetError'],
        data: { assetId, error: 'Customer picture not found' },
      });
      return;
    }

    const response = await opApiRequest(
      '/api/customer/gallery/v1/image/quantize',
      { customerPictureId: Number(customerPictureId), palette: palette.allowedColors },
      'data',
      'POST',
    ) as QuantizeResponse;

    sendPostMessage({
      type: MESSAGE_TYPE['design.setQuantizedAsset'],
      data: {
        assetId,
        file: {
          id: assetId,
          quantizedColors: response.colors || palette.allowedColors,
        },
        url: response.url,
        quantizedUrl: response.url,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[OP-39631] Quantization failed:', error);
    sendPostMessage({
      type: MESSAGE_TYPE['design.setQuantizedAssetError'],
      data: { assetId, error: String(error) },
    });
  }
};

export default handleQuantizedAssetRequestOperation;
